import api from "./api";

export const getSupportTicketsDashboard = () => api.get("/support-tickets/dashboard");

export const getSupportFormData = () => api.get("/support-tickets/form-data");

export const fetchSupportTransaction = (txnId) => {
  const fd = new FormData();
  fd.append("transaction_id", txnId);
  return api.post("/support-tickets/fetch-transaction", fd);
};

export const getSupportTickets = ({
  status = "",
  service = "",
  search = "",
  page = 1,
  limit = 10,
} = {}) =>
  api.get("/support-tickets", {
    params: {
      status: status || undefined,
      service: service || undefined,
      search: search || undefined,
      page,
      limit,
    },
  });

export const submitSupportTicket = ({ transactionId, subject, description, files }) => {
  const fd = new FormData();
  fd.append("transaction_id", transactionId);
  fd.append("subject", subject);
  fd.append("description", description);
  files.forEach((f, i) => fd.append(`proofs[${i}]`, f));
  return api.post("/support-tickets", fd);
};
